function hoverEffects () {
    const hoverContainer = document.querySelector('.hover-container');

    if(hoverContainer) {
        const circle = document.querySelector('.circle');

        hoverContainer.addEventListener('mousemove', (e)=> {
            const rect = hoverContainer.getBoundingClientRect();
            const x = e.clientX - hoverContainer.offsetLeft;
            const y = e.clientY - rect.top;

            circle.style.opacity = 1;
            
            circle.style.top = `${y}px`;
            circle.style.left = `${x}px`;
        });

        hoverContainer.addEventListener('mouseleave', (e)=> {
            circle.style.opacity = 0;
        });
    }
}

export default hoverEffects;